import { IParameter, IUnit } from '@/pages/Parameters/parameters.types.ts'
import { CSSProperties, useMemo } from 'react'
import parametersAtom from '../../parameters.atom'
import { useRecoilValue } from 'recoil'
import { IOption } from '@/types/global'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  value: IParameter['unitId']
  name: string
  onChange: (val: IParameter['unitId'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const ParameterUnitsDropdown = (props: IProps) => {
  const units = useRecoilValue(parametersAtom).units

  const unitsOption: IOption<IUnit['id']>[] = useMemo(() => {
    return units.map((b) => ({ title: b.nameRu, value: b.id }))
  }, [units])

  return (
    <DropdownInput
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      onSelect={props.onChange}
      options={unitsOption}
      selectedOption={props.value}
      title={props.title || 'Выберите единицу измерения'}
    />
  )
}

export default ParameterUnitsDropdown
